module.exports = __webpack_public_path__ + "static/media/secietypic01@2x.df2d1717.png";